import { render, staticRenderFns } from "./Otherbillap.vue?vue&type=template&id=4fad5464"
import script from "./Otherbillap.vue?vue&type=script&lang=js"
export * from "./Otherbillap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports